<script>
import { mapActions } from "vuex";
import { EventBus } from "@/event-bus/event-bus";

export default {
  name: "logout",
  mounted() {
    this.logout().then(() => {
      EventBus.$emit('page-loading', false);
      let parameters = {};
      if(this.$route.query.redirect){
        parameters = {redirect: this.$route.query.redirect}
      }
      this.$router.push({path:"/login",query: parameters})
    });
  },
  methods: {
    ...mapActions(["logout"])
  },
  render() {
    return null;
  }
};
</script>
